import { render, staticRenderFns } from "./ErrorSubmitForm8.vue?vue&type=template&id=342b971a&scoped=true"
import script from "./ErrorSubmitForm8.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm8.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342b971a",
  null
  
)

export default component.exports